import { render, staticRenderFns } from "./SelectRadioGroup.vue?vue&type=template&id=32c559b2&scoped=true&lang=pug"
import script from "./SelectRadioGroup.vue?vue&type=script&lang=js"
export * from "./SelectRadioGroup.vue?vue&type=script&lang=js"
import style0 from "./SelectRadioGroup.vue?vue&type=style&index=0&id=32c559b2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c559b2",
  null
  
)

export default component.exports